import { requestUrl } from "@/config/config";

/**
 * 图片分类接口
 */
export const getCategoryPageList = `${requestUrl}/manage/categorize/page`;

/**
 * 图片分类 新增
 */
export const categoryAdd = `${requestUrl}/manage/categorize/add`;

/**
 * 图片分类 编辑
 */
export const categoryEdit = `${requestUrl}/manage/categorize/edit`;

/**
 * 图片分类 上移下移
 */
export const upAndDown = `${requestUrl}/manage/categorize/upAndDown`;

/**
 * 图片分类 删除
 */
export const categoryDel = (id) =>
  `${requestUrl}/manage/categorize/delete?id=${id}`;

/**
 * 节庆热点 列表
 * */

export const getPicturePageList = `${requestUrl}/manage/festive/page`;

/**
 * 节庆热点 新增
 */
export const festiveAdd = `${requestUrl}/manage/festive/add`;

/**
 * 节庆热点 编辑
 */
export const festiveEdit = `${requestUrl}/manage/festive/edit`;

/**
 * 节庆热点 上移下移
 */
export const festiveUpAndDown = `${requestUrl}/manage/festive/upAndDown`;

/**
 * 节庆热点 删除
 */
export const festiveDel = (id) =>
  `${requestUrl}/manage/festive/delete?id=${id}`;

/**
 * 图片标签 列表
 * */
export const getPageList = `${requestUrl}/manage/picture/page`;

/**
 * 图片标签 编辑
 */
export const pictureEdit = `${requestUrl}/manage/picture/edit`;

/**
 * 图片标签 新增
 */
export const pictureAdd = `${requestUrl}/manage/picture/add`;

/**
 * 图片标签 上移下移
 */
export const pictureUpAndDown = `${requestUrl}/manage/picture/upAndDown`;

/**
 * 图片标签 删除
 */
export const pictureDel = (id) =>
  `${requestUrl}/manage/picture/delete?id=${id}`;
/**
 * 查询展示设置
 */
export const getshowConfig = `${requestUrl}/works-show-config/listAll`;
/**
 * 添加展示设置
 */
export const addShowconfig = `${requestUrl}/works-show-config/add`;
